module.exports = __webpack_public_path__ + "static/media/userEditPencil.a47d162d.svg";